$(document).ready(function($) {
    $('.faq-toggle-btn').each(function() {
        var isExpanded = $(this).hasClass('open');
        $(this).attr('aria-expanded', isExpanded);
    });


    $("a[href='https://www.usatoday.com/picture-gallery/travel/10best/2021/04/24/10-healthy-snacks-you-should-bring-your-next-flight/7358005002/']").attr('aria-label','USA Today, this link opens in new tab you will be leaving this website and go to www.usatoday.com');
$("a[href='https://www.purewow.com/food/healthy-peanut-butter']").attr('aria-label','Pure won, this link opens in new tab you will be leaving this website and go to www.purewow.com');
$("a[href='https://www.laweekly.com/top-ten-last-minute-gifts-for-the-holidays/?fbclid=IwAR0bRInbSaNA8Uz986giq-8Q-9eWhQuu8OuSLvHagRxWv0_rm6EBG7X6ymg']").attr('aria-label','LA Weekly, this link opens in new tab you will be leaving this website and go to www.laweekly.com');


    $('.faq-toggle-btn').on('click', function() {
        $(this).toggleClass('open');
        var expanded = $(this).hasClass('open');
        $(this).attr('aria-expanded', expanded);
    });

    $(".owner-mission .responsive-image-wrapper img").attr("alt", "Supplier Gateway");

    // navonclick

    jQuery(".site-nav__dropdown").hide();



    
    jQuery(".sspreadlovedrop").click(function(){




jQuery(this).toggleClass("is-oopen");
   
if (jQuery(this).parent().children(".site-nav__dropdown").is(':visible')){
jQuery(this).parent().children(".site-nav__dropdown").slideUp();
}else{
jQuery(".site-nav__dropdown").slideUp();
jQuery(this).parent().children(".site-nav__dropdown").slideDown();
}
jQuery(this).attr('aria-expanded', function(i, attr) {
      return attr == 'true' ? 'false' : 'true'
    });
});


   // Handle focus events for VoiceOver
   jQuery(document).on('focusin', function(event) {
    // Check if the focus is outside of elements with class "site-nav--has-dropdown"
    if (jQuery(event.target).closest(".site-nav__dropdown").length === 0) {
      // Close all dropdowns by setting their "aria-expanded" attribute to "false"
      jQuery(".sspreadlovedrop").attr("aria-expanded", "false");
      jQuery(".site-nav__dropdown").removeAttr("style");
      
      // Add your code to hide the dropdown menu as needed here
    }
  });

  $("a[href='https://nativepet.com/products/pumpkin-for-dogs?variant=32966092161067']").attr('target','_blank');
  $("a[href='https://spreadthelovefoods.com/pages/accessibility-statement']").attr('id','accessi');

  $("a[href='https://nativepet.com/products/pumpkin-for-dogs?variant=32966092161067']").attr('aria-label','Native Pet Pumpkin Digestive Powder, this link opens in new tab');
  $("a[href='https://store.edwardandsons.com/products/organic-sweetened-condensed-coconut-milk']").attr('target','_blank');
  $(".thirdlink").attr("target", "_blank");
  $("a[href='https://policies.google.com/privacy']").attr("target", "_blank");
  $("a[href='https://policies.google.com/privacy']").attr("aria-label", "Privacy Policy, this link open in new tab");
  $("a[href='https://policies.google.com/terms']").attr("target", "_blank");
  $("a[href='https://policies.google.com/terms']").attr("aria-label", "Terms of Service, this link open in new tab");
  $("a[href='https://www.iherb.com/c/spread-the-love']").attr("aria-label", "ihurb, ou are leaving spreadthelovefoods.com and going to pk.iherb.com, and this link opens in a new tab.");
  $('.faq-toggle-content a[href="mailto:info@spreadthelovefoods.com"]').attr("aria-label", "Email us at info@spreadthelovefoods.com");
  $('.faq-toggle-content a[href="tel:+4242099870"]').attr("aria-label", "Call us at 424-209-9870");
  $('a[href="mailto:hello@spreadthelovefoods.com"]').attr("aria-label", "Email us at hello@spreadthelovefoods.com");
 $("hr").attr("aria-hidden", "true");
 $("br").attr("aria-hidden", "true");
 $(".overlay").empty().attr("aria-hidden", "true");
 $(".splide__track ul.splide__list li.splide__slide").removeAttr("role");
 $("a[href='https://www.cleaneatingmag.com/clean-pantry/clean-choice-awards/pantry-staples/']").attr("title", "You are leaving spreadthelovefoods.com and going to cleaneatingmag.com, and this link opens in a new tab.");
 $("a[href='https://www.cleaneatingmag.com/clean-pantry/clean-choice-awards/pantry-staples/']").attr("target", "_blank");
 $(document).ready(function () {
  setTimeout(function () {
    $("img[src='https://maps.gstatic.com/mapfiles/transparent.png']").attr("alt", "transparent");
  }, 3000);
}, 3000);

 var intervalID = window.setInterval(myCallback, 50);
 function myCallback() {
     var textAreaCheck = document.getElementsByClassName('g-recaptcha-response');
     if (textAreaCheck.length > 0) {
            jQuery(textAreaCheck).attr('aria-label', 'g-recaptcha-response');
            console.log(jQuery(textAreaCheck));
       clearInterval(intervalID);
     }
  }  

});


  $(document).ready(function () {
    setTimeout(function () {
     
      $('.oke-a11yText').each(function () {
        var textContent = $(this).text().trim(); // Use $(this) instead of jQuery(this)
        $(this).attr('aria-label', textContent);
    });
        $(".oke-a11yText").attr("role", "img");

        $(".rc_popup__hover button").click(function(){
            $(this).toggleClass("active");

            if ($(this).parent().children("div.rc_popup__block").is(':visible')){
                $(this).parent().children("div.rc_popup__block").slideUp();
                }else{
                $("div.rc_popup__block").slideUp();
                $(this).parent().children("div.rc_popup__block").slideDown();
                }

                $(this).attr('aria-expanded', function(i, attr) {
                    return attr == 'true' ? 'false' : 'true'
                  });
        });

            $(".rc_widget__option__selector span").removeAttr("aria-label");
            $(".rc_popup__hover a").attr("aria-label", "POwered by recharge, this link open in new tab");
            $(".oke-stars-background, .oke-stars-foreground").attr("aria-hidden", "true");

            $(".lion-reward-item__more-info-url a").attr("aria-expanded", "false");
            $(".lion-reward-item__more-info-url a").attr("role", "button");
            $(".lion-reward-item__more-info-url a").click(function(){
              $(".lion-reward-item__more-info-url a").attr("aria-expanded", "true");
            });

    }, 7000);
    }, 7000);


    document.addEventListener('DOMContentLoaded', function() {
      var backToTopButton = document.getElementById('back-to-top');
    
      window.onscroll = function() {
          if (window.pageYOffset > 300) {
              backToTopButton.style.display = 'block';
          } else {
              backToTopButton.style.display = 'none';
          }
      };
    
      backToTopButton.onclick = function(e) {
          e.preventDefault();
          window.scrollTo({ top: 0, behavior: 'smooth' });
    
          // Set focus to the top of the page or the button itself after scrolling
          window.setTimeout(function() {
              document.getElementById('backtoheader').focus(); // If focusing the top element
              // backToTopButton.focus(); // If focusing the button itself
          }, 600); // Adjust the timeout duration to match the scroll duration
      };
    });
    // $( document ).ready(function() {
    //   var existCondition = setInterval(function() {
    //    if ($('.swiper-slide').length) { 
    //     clearInterval(existCondition);
    //     runMyFunction2();
    //    }
    //   }, 2000);
    
    //   function runMyFunction2(){
    //    console.log("Slider Loaded");
    //    $('.swiper-slide').attr('aria-hidden', 'true');
    //    $('.swiper-slide.product-medias__primary.swiper-slide-active').attr('aria-hidden', 'false');
    //   }
    // }); 
    
    // document.addEventListener('DOMContentLoaded', function() {
    //   // Function to update aria-hidden based on the active class
    //   function updateAriaHidden() {
    //       var slides = document.querySelectorAll('.swiper-slide');
    //       slides.forEach(function(slide) {
    //           if (slide.classList.contains('swiper-slide-active')) {
    //               // If the slide has the active class, set aria-hidden to false
    //               slide.setAttribute('aria-hidden', 'false');
    //           } else {
    //               // Otherwise, set aria-hidden to true
    //               slide.setAttribute('aria-hidden', 'true');
    //           }
    //       });
    //   }
    
    // //   // Select the navigation buttons
    // //   var navButtons = document.querySelectorAll('.nav-style-1');
    
    // //   // Event listeners for click events on navigation buttons
    // //   navButtons.forEach(function(button) {
    // //       button.addEventListener('click', function() {
    // //           // Wait for the slider to update the active class
    // //           setTimeout(updateAriaHidden, 1000); // Adjust the timeout as needed
    // //       });
    // //   });
    
    //   // Initial update when the page loads
    //   updateAriaHidden();
    // });



jQuery('a').each(function () {
             if (this.hostname && this.hostname !== window.location.hostname && this.hostname !== 'https://spreadthelovefoods.com/') {
               var warningSpan = jQuery('<span class="visually-hidden">: This link will open in a new tab.</span>');
               jQuery(this).attr('target', '_blank').attr('rel', 'noopener noreferrer');
               jQuery(this).append(warningSpan);
            }
          });

